import { render, staticRenderFns } from "./RelatorioInspecaoReport.vue?vue&type=template&id=0bf7d5b7&scoped=true"
import script from "./RelatorioInspecaoReport.vue?vue&type=script&lang=js"
export * from "./RelatorioInspecaoReport.vue?vue&type=script&lang=js"
import style0 from "./RelatorioInspecaoReport.vue?vue&type=style&index=0&id=0bf7d5b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf7d5b7",
  null
  
)

export default component.exports